verifying...